module.exports = {"140723001":"城区管理委员会","140723100":"义兴镇","140723101":"李阳镇","140723102":"松烟镇","140723103":"青城镇","140723104":"横岭镇","140723200":"喂马乡","140723201":"平松乡","140723202":"牛川乡","140723203":"马坊乡","140723204":"阳光占乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140723.json
// module id = 284
// module chunks = 0